var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
export default React.memo(function (props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: 48, height: 48, viewBox: "0 0 48 48" }, props),
        React.createElement("g", { fill: "none", fillRule: "evenodd" },
            React.createElement("circle", { cx: 24, cy: 24, r: 16, fill: "currentColor" }),
            React.createElement("path", { fill: "#FFF", d: "M24 13c-3.038 0-5.5 2.496-5.5 5.576 0 3.08 2.462 5.576 5.5 5.576 3.037 0 5.5-2.497 5.5-5.576C29.5 15.496 27.037 13 24 13zm0 13.484c5.964 0 10.82 2.406 10.995 5.408l.005.168v.6a13.977 13.977 0 01-10.109 5.312l-.385.02-.154.004L24 38l-.345-.004-.305-.01A13.98 13.98 0 0113 32.661v-.601c0-3.08 4.925-5.576 11-5.576z" }))));
});
